<style lang="less">
    @import "../../../styles/table.less";
</style>
<template>
    <div class="search">
        <Row>
            <Col>
                <Card title="继续教育明细">
                    <Row @keydown.enter.native="handleSearch">
                        <Form ref="certificateName" :model="searchForm" inline :label-width="70">
                            <Form-item label="用户名" prop="userName">
                                <Input type="text" v-model="searchForm.userName" placeholder="请输入用户名称" clearable style="width: 200px"/>
                            </Form-item>
                            <Form-item style="margin-left:-35px;" class="br">
                                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                                <Button @click="handleReset">重置</Button>
                                <a class="drop-down" @click="dropDown">{{dropDownContent}}
                                    <Icon :type="dropDownIcon"></Icon>
                                </a>
                            </Form-item>
                        </Form>
                    </Row>
                    <Row>
                        <Table :loading="loading" border :columns="columns"  size="small"  :data="data" sortable="custom" @on-sort-change="changeSort" @on-selection-change="showSelect" ref="table"></Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    import circleLoading from "../../my-components/circle-loading.vue";
    import {continueList} from "@/api/bus";
    import Util from '@/libs/util';
    export default {
        name: "continue-manage",
        components: {
            circleLoading
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    auditState: "",
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "u.createTime", // 默认排序字段
                    order: "desc", // 默认排序方式
                    courseTitle: "",
                    userName: "",
                    startDate: "",
                    endDate: ""
                },
                selectDate: null, //选择日期绑定modal
                columns: [
                    {
                        type: "index",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "用户名称",
                        align: "center",
                        width: 150,
                        key: "userName"
                    },
                    {
                        title: "缴费时间",
                        key: "payTime",
                        align: "center",
                        width: 160
                    },
                    {
                        title: "证书名称",
                        key: "certificateName",
                        align: "center",
                    },
                    {
                        title: "证书编号",
                        width: 150,
                        align: "center",
                        key: "certificateNum"
                    },
                    {
                        title: "学习周期",
                        align: "center",
                        render: (h, params) => {
                            let re = params.row.stuBeginTime + " 至 " + params.row.validity;
                            return h("div", re);
                        }
                    },
                    {
                        title: "目标学时",
                        width: 150,
                        align: "center",
                        key: "tagetPeriod"
                    },
                    {
                        title: "获得课程学时",
                        width: 150,
                        align: "center",
                        key: "coursePeriod"
                    },
                    {
                        title: "获得活动学时",
                        width: 150,
                        align: "center",
                        key: "activityPeriod"
                    },
                    {
                        title: "完成继续教育",
                        width: 150,
                        align: "center",
                        key: "isFull",
                        render: (h, params) => {
                            if (params.row.isFull === 0) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "blue"
                                            }
                                        },
                                        "未完成"
                                    )
                                ]);
                            } else if(params.row.isFull === 1){
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "green"
                                            }
                                        },
                                        "已完成"
                                    )
                                ]);
                            } else {
                                return h("div", "--");
                            }
                        }
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            init() {
                this.getDataList();
            },
            getDataList() {
                this.loading = true;
                continueList(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            //设置课程推荐状态
            handleSearch() {
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.getDataList();
            },
            handleReset() {
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.selectDate = null;
                this.searchForm.startDate = "";
                this.searchForm.endDate = "";
                this.searchForm.auditState = "";
                this.searchForm.userName = "";
                // 重新加载数据
                this.getDataList();
            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            selectDateRange(v) {
                if (v) {
                    this.searchForm.startDate = v[0];
                    this.searchForm.endDate = v[1];
                }
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            showSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
        },
        mounted() {
            this.init();
        }
    }
</script>
